import { useNavigate } from 'react-router-dom';
import { Col, DatePicker, Input, Row } from 'antd';
import { useGetGendersQuery, useGetNameSuffixesQuery, useGetRacesQuery } from '@/services/general-api';
import { SaveSvg, UserSvg } from '@/assets/icons';
import Select from '@/components/select';
import Panel from '@/components/panel';
import FixedFooter from '@/components/fixed-footer';
import Button from '@/components/button';
import { Form } from '../add-child/styles';
import { useAddGroupMembersMutation } from '@/services/sibling-group-api';
import _ from 'lodash';
import moment from 'moment';

const { TextArea } = Input;

const AddForm = ({ groupData }) => {
  const navigate = useNavigate();

  const { data: suffixData, isLoading: loadingSuffixData } = useGetNameSuffixesQuery();
  const { data: genderData, isLoading: loadingGenderData } = useGetGendersQuery();
  const { data: raceData, isLoading: loadingRaceData } = useGetRacesQuery();
  const [addMembers, { isLoading: adding }] = useAddGroupMembersMutation();

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const body = _.cloneDeep(values);
    body.children.forEach((item, i) => {
      item.birthInfo.date = item.birthInfo.date.toISOString();
      body.children[i] = {
        ...item,
        childCode: groupData.childCode + String.fromCharCode(65 + i),
      };
    });
    try {
      await addMembers({ groupId: groupData.siblingGroupId, body }).unwrap();
      navigate('../view');
    } catch (err) {}
  };

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={{
        children: Array.from({ length: groupData.entrySiblings }).map(() => ({})),
      }}
      onFinish={onFinish}
      style={{ marginBottom: 58 }}
    >
      <Form.List name="children">
        {(fields) =>
          fields.map((field, i) => {
            return (
              <Panel key={i} icon={<UserSvg />} title={`Child - ${groupData.childCode + String.fromCharCode(65 + i)}`}>
                <Row gutter={32}>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'name', 'first']} label="First Name" rules={[{ required: true }]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'name', 'last']} label="Last Name" rules={[{ required: true }]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'name', 'suffix']} label="Suffix">
                      <Select options={suffixData} valueName="code" loading={loadingSuffixData} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'birthInfo', 'date']} label="Birth Date" rules={[{ required: true }]}>
                      <DatePicker
                        format="MM/DD/YYYY"
                        onBlur={(e) => {
                          const inputVal = e.target.value;
                          const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
                          if (validDate.isValid()) {
                            form.setFieldsValue({
                              [field.name]: {
                                ...form.getFieldValue([field.name]),
                                birthInfo: {
                                  ...form.getFieldValue([field.name, 'birthInfo']),
                                  date: validDate,
                                },
                              },
                            });
                          } else {
                            form.setFieldsValue({
                              [field.name]: {
                                ...form.getFieldValue([field.name]),
                                birthInfo: {
                                  ...form.getFieldValue([field.name, 'birthInfo']),
                                  date: null,
                                },
                              },
                            });
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'gender', 'id']} label="Gender" rules={[{ required: true }]}>
                      <Select options={genderData} loading={loadingGenderData} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'race', 'id']} label="Race/Ethnicity" rules={[{ required: true }]}>
                      <Select options={raceData} loading={loadingRaceData} showSearch />
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item name={[field.name, 'bio']} label="Bio">
                      <TextArea autoSize={{ minRows: 2 }} />
                    </Form.Item>
                  </Col>

                  {/* <Col xs={24} md={12} xl={8}>
                    <Form.Item name={[field.name, 'task', 'type', 'id']} label="Type">
                      <Select options={taskTypeData} loading={loadingTaskTypeData} allowClear />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} xl={8}>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, currentValues) =>
                        prevValues.task.type?.id !== currentValues.task.type?.id
                      }
                    >
                      {({ getFieldValue }) => {
                        const typeId = getFieldValue('task')?.type?.id;
                        if (!typeId) {
                          form.setFieldValue([field.name, 'task', 'status', 'id'], undefined);
                          return null;
                        }
                        return (
                          <Form.Item
                            name={[field.name, 'task', 'status', 'id']}
                            label="Status"
                            rules={[{ required: true }]}
                          >
                            <Select options={taskStatusData} loading={loadingTaskStatusData} />
                          </Form.Item>
                        );
                      }}
                    </Form.Item>
                  </Col> */}
                </Row>
              </Panel>
            );
          })
        }
      </Form.List>

      <FixedFooter>
        <Button type="primary" htmlType="submit" icon={<SaveSvg />} loading={adding}>
          Save
        </Button>
      </FixedFooter>
    </Form>
  );
};

export default AddForm;
